export default __webpack_public_path__ + "static/media/gs-1.5af6853a.png";